import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const onLanguageSelected = async (action, _datastore, { setDatastore, goBack }) => {
    await SharedPropsService.setFilteredList(action.payload.value);
    await setDatastore(ROUTE.COLLATERAL_LANGUAGE_SELECT, "collateralLanguageFilterSelect", {
        filtersSelected: []
    });
    await goBack();
};
export const onResetFilter = async (action, _datastore, { goBack }) => {
    await goBack();
    await SharedPropsService.setFilteredList(action.payload.value);
};
